import * as React from 'react';
import { ComponentLayout } from 'src/components/common/modules/component-layout/code-split/component-layout-component';
import { ComponentLayoutType } from 'src/components/common/modules/component-layout/component-layout';
import { V3TravelHubHeroComponent } from './code-split/TravelHubHero/v3-hero-module-component';
import { V3HeroModuleComponent } from './styles/shared';
import {V3EpisodePlayerComponent} from "./code-split/TravelHubHeroEpisodes/v3-episode-player-component";

const V3HeroModule: React.FC<ComponentLayoutType<any>> = (props) => {

  const moduleNamespace = props?.data.module;
  return (
    <ComponentLayout {...props}>
      {moduleNamespace === 'v3HeroModule' && 
          (<V3HeroModuleComponent>
            <V3TravelHubHeroComponent />
          </V3HeroModuleComponent>)}
      
          {moduleNamespace === 'v3HeroCinemaModule' && 
            ( <V3EpisodePlayerComponent />)}
    </ComponentLayout>
  );
};

export default V3HeroModule;
